
import * as settings from '../settings'
import React from 'react';
import { useNavigate } from "react-router-dom";

export const replaceAll = (str, find, replace) => {
  str = str.replace(find, replace).replace(find, replace).replace(find, replace).replace(find, replace).replace(find, replace).replace(find, replace).replace(find, replace).replace(find, replace).replace(find, replace).replace(find, replace)
  return str
}

export const isNumeric = (str) => {
  if (typeof str != "string") return false // we only process strings!  
  return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

export const deleteAreaCode = (phone) => {
  if (phone.substring(0, 4) === '+972') return phone.replace('+972', '0')
  return phone
}
export const getNumberWithIsraelAreaCode = (phone) => {
  if (phone.substring(0, 1) === '0') return phone.replace('0', '+972')
  return phone

}

export const deleteUnnecessaryPhoneChars = (phone) => {
  return replaceAll(replaceAll(replaceAll(replaceAll(phone, '-', ''), ' ', ''), '(', ''), ')', '')
}

export const convertDateTimeToApplicationTime = (date) => {
  const formatedYear = date.getFullYear()
  const formatedMonth = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : '' + (date.getMonth() + 1)
  const formatedDay = date.getDate() < 10 ? '0' + date.getDate() : '' + date.getDate()
  const formatedHours = date.getHours() < 10 ? '0' + date.getHours() : '' + date.getHours()
  const formatedMinutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : '' + date.getMinutes()
  const formatted_date = formatedDay + '/' + formatedMonth + '/' + formatedYear + ' ' + formatedHours + ':' + formatedMinutes
  return formatted_date
}

export const formatDateFromDB = (dateString, short) => {
  const date = new Date(dateString);
  const pad = (num) => num.toString().padStart(2, '0');

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  if (!short) {
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }
  else {
    return `${day}/${month}/${year.toString().slice(-2)} ${hours}:${minutes}`;
  }
}



export const removeSpecialChars = (msg) => {
  if (msg.includes('<?') || msg.includes('?>')) {
    return msg.replace(/<\?/g, '?').replace(/\?>/g, '?');
  }
  return msg;
}

export const formatDuration = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  // Pad each number with a leading zero if it is less than 10
  const paddedHours = hours.toString().padStart(2, '0');
  const paddedMinutes = minutes.toString().padStart(2, '0');
  const paddedSeconds = remainingSeconds.toString().padStart(2, '0');

  return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
}

export const isTodayDateTime = (dateTime) => {
  const dateTimeObj = new Date(dateTime)

  // Set the time of startOfToday to midnight
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);

  // Set the time of endOfToday to the last millisecond of today
  const endOfToday = new Date(startOfToday);
  endOfToday.setHours(23, 59, 59, 999);

  return dateTimeObj >= startOfToday && dateTimeObj <= endOfToday;
}

export const formatDateToSQLServer = (date) => {
  const padZero = (num, size) => {
    let s = num.toString();
    while (s.length < size) s = "0" + s;
    return s;
  };

  const year = date.getFullYear();
  const month = padZero(date.getMonth() + 1, 2); // Months are zero-based
  const day = padZero(date.getDate(), 2);
  const hours = padZero(date.getHours(), 2);
  const minutes = padZero(date.getMinutes(), 2);
  const seconds = padZero(date.getSeconds(), 2);
  const milliseconds = padZero(date.getMilliseconds(), 3);

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
}

export const getFileTypeByContentType = (contentType) => {
  switch (contentType) {
    case 'image/jpeg':
      return 'jpeg'
    case 'application/pdf':
      return 'pdf'
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return 'docx'
    case 'application/msword':
      return 'doc'
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      return 'pptx'
    case 'application/vnd.ms-powerpoint':
      return 'ppt'
    case 'audio/mpeg':
      return 'mp3'
    case 'audio/ogg':
      return 'ogg'
    case 'audio/wav':
      return 'wav'
    case 'audio/x-m4a':
      return 'm4a'
    case 'audio/aac':
      return 'aac'
    case 'video/mp4':
      return 'mp4'
    case 'text/plain':
      return 'txt'
    case 'text/csv':
      return 'csv'
    case 'application/vnd.ms-excel':
      return 'xls'
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return 'xlsx'
    case 'audio/webm':
    case 'video/webm':
      return 'webm'
    default:
      return contentType.split('/')[1]
  }
}

export const isPbxSupportActionType = (pbxType, actionType) => settings.PBX_SUPPORT_ACTIONS?.[actionType]?.includes(pbxType)


export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  }
  return ComponentWithRouterProp;
}

export function getContactNameByConv(conv) {
  let contactName
  if (conv?.crmId && typeof conv.crmId === 'object' && conv.crmId.name) {//?.crmId?.name
    contactName = conv.crmId.name
  }
  else if (conv?.contactId && typeof conv.contactId === 'object') {
    contactName = conv.contactId.fullName
  }
  else if (conv?.displayName) {
    contactName = conv.displayName
  }
  return contactName
}